export const SearchEntity = {
    debounce_time: 1000,
    clear_search_input: false
}

export const PaginationLimit = {
    university: 500
}

export const ApplicationTabsIndex = {
    student_details: 0,
    documents: 1,
    application_history: 2,
    comments: 3,
    university_communication: 3,
    call_recordings: 4
}


export const ProfileTabsIndex = {
    administrator_details: 0,
    company_details: 1,
    bank_details: 2,
    documents: 3,
    upload_company_logo: 4,
    transactionList: 4,
    download:5
}

export const ErrorMsg = {
    already_course_exist: 'course is already applied!!'
}

export const fileHost = 'https://crizac-assets.s3.ap-south-1.amazonaws.com/system';
export const CourseType = {
    undergraduate: 'Undergraduate',
    postgraduate: 'Postgraduate'
}

export const localStorageVars = {
    userId: 'userId',
    userObj:'userObj',
    token: 'token',
    tempUserObj: 'temUserObj',
    selectedCoursesObject: 'selectedCourse'
}

export const EntryRequirements = {
    pg: 'PG Entry Reuirements',
    ug: 'UG Entry Reuirements'
}